import { signOut } from "firebase/auth";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router";
import { auth } from "../../firebase/client";
import { useCurrentUser } from "../../hooks/use-current-user";
import { resetBroadcast } from "../../redux/broadcast/broadcast.actions";
import { selectBroadcastId } from "../../redux/broadcast/broadcast.selectors";
import ToolbarControls from "./components/toolbar-controls";
import * as CSS from "./toolbar.styles";

const Toolbar = () => {
	const user = useCurrentUser();
	const broadcastId = useSelector(selectBroadcastId);
	const dispatch = useDispatch();

	const handleSignOut = () => {
		dispatch(resetBroadcast());
		signOut(auth);
	};

	return (
		<CSS.Toolbar>
			<span>
				<Link to="/" style={{ fontWeight: "bold" }}>
					Rabble
				</Link>
			</span>

			{broadcastId !== null && <ToolbarControls />}

			<div style={{ display: "flex", gap: "0.5rem" }}>
				{user?.admin && <Link to="/admin">Admin</Link>}
				{user && <Link to={`/author/${user.uid}`}>My profile</Link>}
				<Link to="/settings">Settings</Link>
				{user && <span className="toolbar-email">{user.email}</span>}
				{user ? (
					<button type="button" onClick={handleSignOut}>
						Sign out
					</button>
				) : (
					<Link to="/register">Register</Link>
				)}
			</div>
		</CSS.Toolbar>
	);
};

export default Toolbar;
